<template>
  <div>
    <common-dialog
      ref="dialog"
      width="500px"
      show-save-button
      unit="分类"
      edit-title
      id-key="ClassId"
      :data="data"
      :form-rules="rules"
      :save-func="api.save"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      close-on-saved
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <el-form-item label="上级分类" prop="PName">
              <span>{{data.PName}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="当前分类" prop="ClassName">
              <el-input v-model="data.ClassName" placeholder="请输入分类名称"></el-input>
            </el-form-item>
            <el-form-item label="分类编码" prop="ClassCode">
              <el-input v-model="data.ClassCode" placeholder="请输入分类编码"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        ClassId: 0,
        ClassCode: "",
        ClassName: "",
        Pid: 0,
        PName: "",
        ClassType: 0,
      },
      api: require("@/api/ba/class").default,
      rules: {
        ClassCode: [{ required: true, message: "分类编码不能为空" }],
        ClassName: [{ required: true, message: "分类名称不能为空" }],
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened(data) {
      
    },
    onEditOpened(data) {
      
    },
  },
};
</script>